import { useState, useRef, useEffect } from 'react';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export default function Hero() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCategorySelect = (url: string) => {
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20editorial%20product%20collage%20with%20soft%20cream%20and%20sandy%20beige%20tones%2C%20fashion%20accessories%20and%20lifestyle%20items%20arranged%20organically%20on%20a%20clean%20studio%20surface%2C%20diffused%20golden%20hour%20window%20lighting%20streaming%20diagonally%2C%20subtle%20textile%20textures%20visible%2C%20marble%20and%20linen%20backgrounds%2C%20Scandinavian%20aesthetic%2C%20high-end%20lifestyle%20catalog%20look%2C%20gentle%20shadows%2C%20elegant%20sophisticated%20composition%2C%20no%20text%20or%20logos&width=1800&height=1200&seq=hero-main-bg-v2-2026&orientation=landscape"
          alt="Superbuy Spreadsheet curated fashion products collage"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50 z-[1]"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 flex flex-col items-center text-center pt-20 pb-16">
        <div className="animate-fade-in">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-white text-xs font-medium tracking-wide mb-8">
            <i className="ri-sparkling-line w-3.5 h-3.5 flex items-center justify-center"></i>
            Best Superbuy Spreadsheet 2026
          </span>
        </div>

        <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.05] mb-6 animate-fade-in-up">
          Curated Links.
          <br />
          Zero Hassle.
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-[580px] mb-10 animate-fade-in-up animation-delay-200 leading-relaxed">
          Discover the most complete Superbuy Spreadsheet — thousands of hand-picked products across every category, updated daily for smarter shopping.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-8 animate-fade-in-up animation-delay-400">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-sm"
          >
            superbuy sheet
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/90 text-foreground-950 font-semibold rounded-full hover:bg-white transition-all whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
          >
            buy it now
            <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="relative animate-fade-in-up animation-delay-600" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center gap-3 px-6 py-3.5 bg-white rounded-2xl border border-background-200/80 text-foreground-900 font-medium text-sm hover:border-background-300 transition-colors min-w-[280px] justify-between cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-grid-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
              Browse Product Categories
            </span>
            <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-2xl border border-background-200/80 overflow-hidden z-50 max-h-[380px] overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleCategorySelect(cat.url)}
                  className="w-full text-left px-5 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors flex items-center justify-between group cursor-pointer whitespace-nowrap"
                >
                  <span>{cat.name}</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-foreground-400 group-hover:text-accent-500 transition-colors opacity-0 group-hover:opacity-100"></i>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 flex justify-center pb-6">
        <a href="#categories" className="flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors cursor-pointer">
          <span className="text-xs font-medium tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}